import { BenefitBannerVariant } from "./BenefitBanner.types";
import { colors } from "../../../theme/foundations/generated";
export const getBackgroundColor = (variant) => {
    if (variant === BenefitBannerVariant.HEALTH_LIFE) {
        return "semantic.brand.quaternary-dimmed";
    }
    if (variant === BenefitBannerVariant.EXPENSES) {
        return "semantic.brand.tertiary-dimmed";
    }
    if (variant === BenefitBannerVariant.FLEET) {
        return "semantic.brand.quinary-dimmed";
    }
    return "semantic.brand.secondary-dimmed";
};
export const getBorderColor = (variant) => {
    if (variant === BenefitBannerVariant.HEALTH_LIFE) {
        return colors.semantic.brand.quaternary;
    }
    if (variant === BenefitBannerVariant.EXPENSES) {
        return colors.semantic.brand.tertiary;
    }
    if (variant === BenefitBannerVariant.FLEET) {
        return colors.semantic.brand.quinary;
    }
    return colors.semantic.brand.secondary;
};
//# sourceMappingURL=helpers.js.map